<template>
    <div style="overflow: hidden;position: relative;">
        <!-- <div class="back"></div> -->
        <div class="mhead">
            <div class="container">
                <div class="mhead-left" >
                    <ul>
                        <li>
                            <a :class="routeName=='home'?'on':''" @click="clickHome" href="#/home">首页</a>
                        </li>
                        <li>
                            <a :class="routeName=='case'?'on':''" @click="clickCase" href="#/case">案例</a>
                        </li>
                        <li>
                            <a :class="routeName=='about'?'on':''" href="#/about">青橙</a>
                        </li>
                        <li>
                            <a :class="(routeName=='business' || routeName=='businessDetail')?'on':''" href="#/business">资讯</a>
                        </li>
                        <li>
                            <a :class="routeName=='joinUs'?'on':''" href="#/joinUs">加入我们</a>
                        </li>
                    </ul>
                </div>
                <div class="mhead-center">
                    <img src="@/assets/img/CORANGE@2x.png" alt="">
                </div>  
                <div class="mhead-right">
                    <div class="input">
                        <input type="text" placeholder="黑电" v-model="searchKey" @focus="focus" @blur="blur" @input="change" placeholder-class="placeinput">
                        <img src="@/assets/img/Group 80@2x.png" alt="">
                    </div>
                </div>
            </div>
            <div class="searchBox" v-show="showSearch">
                <div class="result">
                    {{list.length}}个搜索结果
                </div>
                <div class="list">
                    <div class="item" v-for="item in list" :key="item.id +'-'+ (item.caseName || item.name)">
                        <p class="title">{{item.name || item.caseName}}</p>
                        <p class="desc">{{item.remarks}}</p>
                        <p class="url"><a :href="'http://www.corange.com/#/' + ( item.caseName ? 'detail' : 'businessDetail' ) + '/' + item.id">{{ 'http://www.corange.com/#/' + ( item.caseName ? 'detail' : 'businessDetail' ) + '/' + item.id}}</a></p>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'back' +(showSearch?' show':'')" @click="showSearch=false">

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            routeName: '',
            searchKey: '',
            showSearch: false,
            allList: []
        }
    },
    props: ['caseFun'],
    name: 'mHead',
    computed: {
        list: function() {
            let list = this.allList.filter(item => {
                return (item.caseName && item.caseName.indexOf(this.searchKey) > -1) || (item.name && item.name.indexOf(this.searchKey) > -1)
            })
            return list || []
        }
    },
    created() {
        
    },
    mounted() {
        this.routeName = this.$route.name;
        // console.log(this.$route.name);
    },
    methods: {
        clickCase(){
            this.routeName = 'case'
            this.caseFun();
        },
        clickHome(){
            this.routeName = 'home'
        },
        focus(){
            if(this.searchKey.length == 0) {
                this.showSearch = false;
            } else {
                this.showSearch = true;
            }
        },
        change(){
            if(this.searchKey.length == 0) {
                this.showSearch = false;
            } else {
                this.showSearch = true;
            }
            if(this.allList.length == 0) {
                this.getInfoList();
                this.getCaseList();
            }
        },
        blur(){
            if(this.searchKey.length == 0) {
                this.showSearch = false;
            }
        },
        getInfoList(){
            this.$http.get(this.service.dev.api.infoList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })

                  this.allList = [...list, ...this.allList];
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        getCaseList(){
            this.$http.get(this.service.dev.api.caseList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })

                  this.allList = [...list, ...this.allList];
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
    }
}
</script>
<style lang="scss" scoped>

@media screen and (max-width: 1920px){
    .mhead{
        .container {
            width: 75%;
        }
        .mhead-left {
            ul {
                li {
                    padding: 0px 31px;
                }
            }
        }
    }
}
@media screen and (min-width:1920px) {
    .mhead{
        .container {
            // width: 1440px;
        }
    }
    .mhead-left {
        ul {
            li {
                padding: 0px 31px;
            }
        }
    }
}
@media screen and (max-width: 1440px){
    .mhead{
        .mhead-left {
            ul {
                li {
                    padding: 0px 20px;
                }
            }
        }
        .mhead-right {
            // display: none;
        }
    }
}
@media screen and (max-width: 1100px){
    .mhead{
        .mhead-left {
            ul {
                li {
                    padding: 0px 16px;
                }
            }
        }
        .mhead-right {
            // display: none;
        }
    }
}
    .back {
        background: rgba(232,232,237,.4);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        visibility: hidden;
        position: fixed;
        opacity: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
        transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-end 80ms;
        &.show {
            visibility: visible;
            opacity: 1;
            transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-start 80ms;
        }
        
    }
    .mhead {
        // width: 100%;
        height: 52px;
        // min-width: 1080px;
        background: rgba(255, 255, 255, 0.98);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99;
        .searchBox {
            width: 100%;
            background: inherit;
            text-align: left;
            .result {
                padding: 40px 0px 24px 200px;
                width: 87.5%;
                margin-left: 12.5%;
                // margin: 0 auto;
                // max-width: 1200px;
                box-sizing: border-box;
            }
            .list {
                border-top: 1px solid rgba(0,0,0,0.1);
                padding: 40px 0 80px 200px;
                width: 87.5%;
                margin-left: 12.5%;
                // max-width: 1400px;
                box-sizing: border-box;
                max-height: 40vh;
                overflow-y: auto;
                .item {
                    margin-bottom: 40px;
                    .title {
                        font-size: 16px;
                        color: #000000;
                    }
                    .desc {
                        width: 600px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        color: rgba(0,0,0,0.4);
                        margin: 6px 0;
                    }
                    .url {
                        a {
                            font-size: 14px;
                            color: #327FDA;
                            cursor: pointer;
                            text-decoration: none;  
                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }

                }
                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                    opacity: 0.2;
                }
            }
        }
        .filter {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            backdrop-filter: blur(1px);
            opacity: 0.2;
            z-index: 0;
        }
        .container {
            // width: 1440px;
            height: 52px;
            margin: auto;
            z-index: 99;
            position: relative;
            max-width: 1200px;
            display: flex;
            justify-content: space-between;

            .mhead-center {
                // width: 110px;
                margin: 0 auto;
                display: inline-block;
                // margin-right: 200px;
                img {
                    height: 17px;
                    margin-top: 17px;
                    width: 110px;
                }
            }
            >div {
                height: 100%;
                &.mhead-left {
                    // float: left;
                    width: 500px;
                    ul {
                        margin: 0px; 
                        height: 100%;
                        padding: 0;
                        >li {
                            height: 100%;
                            float: left;
                            list-style: none;
                            
                            font-size: 12px;
                            cursor: pointer;
                            display: flex;             /*flex弹性布局*/
                            // justify-content: center;
                            align-items: center;
                            // padding: 0px 31px;
                            &:first-child {
                                padding-left: 0;
                            }
                            &:hover a {
                                color: #000000;
                            }
                            a {
                                display: inline-block;
                                line-height: 52px;
                                text-decoration: none;
                                color: rgba(0,0,0,0.6);;
                                &.on {
                                    color: #000000;
                                }
                            } 
                        }
                    }
                }
                &.mhead-right {
                    // float: right;
                    height: 100%;
                    width: 500px;
                    .input {
                        width: 224px;
                        height: 36px;
                        margin-top: 8px;
                        border: 1px solid rgba(0,0,0,0.2);
                        box-sizing: border-box;
                        position: relative;
                        text-align: left;
                        float: right;
                        input {
                            border: 0;
                            background: inherit;
                            width: calc(100% - 48px);
                            margin-left:12px;
                            height: calc(100% - 16px);
                            margin-top: 8px;
                            font-size: 12px;
                            &:focus{
                                outline: none;
                                border: none;
                            }
                        }
                        input::input-placeholder {
                            font-size: 12px;
                            color: rgba(0,0,0,0.5);
                        }
                        input::-webkit-input-placeholder {
                            font-size: 12px;
                            color: rgba(0,0,0,0.5);
                        }
                        input::-moz-input-placeholder {
                            font-size: 12px;
                            color: rgba(0,0,0,0.5);
                        }
                        input::-ms-input-placeholder {
                            font-size: 12px;
                            color: rgba(0,0,0,0.5);
                        }
                        .placeinput {
                            font-size: 12px;
                        }
                        img {
                            position: absolute;
                            right: 12px;
                            top: 11px;
                            width: 12px;
                            height: 12px;
                            cursor: pointer;
                        }
                    }
                }
            }
        } 
        
    }
</style>





// WEBPACK FOOTER //
// src/components/base/pc/mHead.vue